"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var debug_1 = require("debug");
var utils_1 = require("../utils");
var API = require("../api");
var validation_1 = require("../validation");
var Req = require("../request");
var Client = (function () {
    function Client(config) {
        var _this = this;
        this.config = config;
        this.latestRequestID = undefined;
        this.getLatestRequestID = function () { return _this.latestRequestID; };
        debug_1.default('sdk:client:config')(config);
    }
    Client.prototype.send = function (req, opts) {
        if (opts === void 0) { opts = {}; }
        var request = this.buildRequest(req, opts);
        debug_1.default('sdk:client:request')(request);
        return API.send(request, this.getLatestRequestID);
    };
    Client.prototype.buildRequest = function (req, opts) {
        var endpoint = this.getEndpoint(req);
        var url = this.getUrl(endpoint);
        var body = this.getRequestBody(req, endpoint);
        var method = this.config.method;
        var retryCount = this.config.retryCount;
        var options = this.getOptions(req, opts);
        var id = this.latestRequestID = utils_1.generateRID();
        return { url: url, body: body, method: method, retryCount: retryCount, options: options, id: id };
    };
    Client.prototype.getEndpoint = function (req) {
        switch (req.type) {
            case Req.Type.Autocomplete:
                return { path: "/autocomplete" };
            case Req.Type.Search:
                return { path: "/search" };
            case Req.Type.Content:
                return { path: "/search/content" };
            case Req.Type.SmartCollection:
                return {
                    path: "/smart-collection/" + req.params.slot,
                    params: ['slot'],
                };
            case Req.Type.Recommendations:
                return this.getRecommendationsEndpoint(req.params);
            case Req.Type.Feedback:
                return { path: "/feedback" };
            default:
                throw new Error('Invalid request type');
        }
    };
    Client.prototype.getRecommendationUrl = function (params) {
        if (Boolean(params.slot)) {
            return "/recommend/" + params.slot;
        }
        switch (params.type) {
            case Req.Recommendations.Type.Featured:
                return "/recommend/items/featured";
            case Req.Recommendations.Type.Newest:
                return "/recommend/items/newest";
            case Req.Recommendations.Type.Trending:
                return "/recommend/items/trending";
            case Req.Recommendations.Type.RecentlyViewed:
                return "/recommend/items/viewed/latest";
            case Req.Recommendations.Type.Slot:
                return "/recommend/" + params.slot;
            case Req.Recommendations.Type.AlsoViewed:
                return "/recommend/items/" + params.item_id + "/viewed/viewed";
            case Req.Recommendations.Type.AlsoBought:
                return "/recommend/items/" + params.item_id + "/viewed/bought";
            case Req.Recommendations.Type.FrequentlyPurchasedTogether:
                var ids = params.item_ids.join(',');
                return "/recommend/items/" + ids + "/bought/bought";
            default:
                throw new Error('Invalid recommendations type');
        }
    };
    Client.prototype.getRecommendationsParams = function (params) {
        switch (params.type) {
            case Req.Recommendations.Type.Slot:
                return ['slot'];
            case Req.Recommendations.Type.AlsoViewed:
                return ['item_id'];
            case Req.Recommendations.Type.AlsoBought:
                return ['item_id'];
            case Req.Recommendations.Type.FrequentlyPurchasedTogether:
                return ['item_ids'];
            default:
                return undefined;
        }
    };
    Client.prototype.getRecommendationsEndpoint = function (params) {
        return {
            path: this.getRecommendationUrl(params),
            params: this.getRecommendationsParams(params)
        };
    };
    Client.prototype.getUrl = function (endpoint) {
        return "" + this.config.url + endpoint.path;
    };
    Client.prototype.getRequestBody = function (req, endpoint) {
        var common = this.getCommonParams(req);
        var specific = this.getSpecificParams(req, endpoint);
        return __assign({}, common, specific);
    };
    Client.prototype.getCommonParams = function (req) {
        var user = req.params.user || this.config.user;
        validation_1.validateUser(user);
        return {
            user: user,
            t_client: Date.now(),
            key: this.config.key,
            log: this.config.log,
        };
    };
    Client.prototype.getSpecificParams = function (req, endpoint) {
        var pathParams = endpoint.params || [];
        var omitParams = function (ks) {
            return utils_1.omit(pathParams.concat(ks), req.params);
        };
        switch (req.type) {
            case Req.Type.Recommendations:
                return omitParams(['type']);
            case Req.Type.Feedback:
                return omitParams(['event']);
            default:
                return req.params;
        }
    };
    Client.prototype.getOptions = function (req, opts) {
        return __assign({ timeout: this.config.timeout }, opts);
    };
    return Client;
}());
exports.Client = Client;
//# sourceMappingURL=Client.js.map